angular.module('dnecom')
    .directive('stringToNumber', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function(value) {
                    return value || value === 0 ? '' + value : null;
                });

                ngModel.$formatters.push(function(value) {
                    return value || value === 0 ? parseFloat(value, 10) : '';
                });
            }
        };
    });
